var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWheelchairArmrests(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.17,10.57H14.26c-.83,0-1.5,.67-1.5,1.5v28.33c0,.51,.27,.99,.69,1.26,.22,.14,5.39,3.58,5.39,12.29,0,.83,.67,1.5,1.5,1.5h7.83c.83,0,1.5-.67,1.5-1.5V12.07c0-.83-.67-1.5-1.5-1.5Zm-1.5,41.88h-4.88c-.47-7.54-4.4-11.48-6.04-12.81V13.57h10.91V52.45Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.28,24.36c-.22-.14-5.39-3.58-5.39-12.29,0-.83-.67-1.5-1.5-1.5h-7.83c-.83,0-1.5,.67-1.5,1.5V53.95c0,.83,.67,1.5,1.5,1.5h13.91c.83,0,1.5-.67,1.5-1.5V25.62c0-.51-.27-.99-.69-1.26Zm-2.31,28.09h-10.91V13.57h4.88c.47,7.54,4.4,11.48,6.04,12.81v26.07Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWheelchairArmrests);
export default __webpack_public_path__ + "static/media/wheelchair_armrests.2fbd95cb.svg";
export { ForwardRef as ReactComponent };